module.exports = __webpack_public_path__ + "static/media/img-7883d29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/bf-logo.png
// module id = 5277
// module chunks = 39